// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--2d913";
export var georgetown = "Footer-module--georgetown--de192";